
























































import { Component, Prop, Vue } from "vue-property-decorator";
import Markdown from "@/components/Markdown.vue";
import { CPTModelI, CPTDataI } from "@/models/cpt/CPTModel";
import { JSONSchema6 } from "json-schema";

@Component({
  components: {
    Markdown,
  },
})
/**
 * Displays a visible summary of the rendered cpt data
 */
export default class ModelPreview extends Vue {
  /**
   * The cpt data
   */
  @Prop({ required: true }) readonly cpt!: CPTModelI;

  /**
   * The json schema for the content
   */
  @Prop({ required: true }) readonly jsonSchema!: Partial<JSONSchema6>;

  /**
   * return solely the data
   */
  get modelData(): CPTDataI | null {
    return this.cpt?.data;
  }

  /**
   * get the definition of a specific field from the schema by it's key
   */
  getFieldSchemaType(key: string): string {
    // the attributes are always available, this is a Gitlify convention
    // eslint-disable-next-line
    return (this.jsonSchema?.properties?.data as any).properties?.attributes
      ?.properties[key];
  }

  /**
   * format a string and check its types
   * @param text
   */
  formatText(text: string): string {
    if (text.includes("http" || text.includes("https"))) {
      return text.substring(text.lastIndexOf("/") + 1);
    }
    return text;
  }

  /**
   * format the key into a readable title
   */
  formatTitle(originalText: string): string {
    // split camel case
    let modifiedText = originalText.replace(/([a-z0-9])([A-Z])/g, "$1 $2");
    // and split - or _
    const splits = modifiedText.split(/[-_]+/);
    return splits.join(" ");
  }
}
